import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipRules {
                        id
                        name,
                        is_real_time,
                        is_unique_dispatch,
                        repeat_each_time,
                        repeat_each_seasonality,
                        ruleEventType {
                            id,
                            name
                        },
                        stops_at,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    fetchById(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipRules (
                        id: ${id},
                    ) {
                        id
                        name,
                        is_real_time,
                        is_unique_dispatch,
                        repeat_each_time,
                        repeat_each_seasonality,
                        ruleEventType {
                            id,
                            name
                        },
                        stops_at,
                        created_at,
                        updated_at,
                        relationshipConditions {
                            id,
                            type,
                            relationship_condition_models_value,
                            relationshipConditionField {
                                id,
                                name
                            },
                            relationshipConditionOperator {
                                id,
                                name
                            },
                            relationshipConditionDataType {
                                id,
                                name
                            },
                            parent_id,
                            parent {
                                id
                            },
                        },
                        categories {
                            id,
                            name,
                            color_tag
                        }
                    }
                }
            `
        })
    },
    fetchWhere(name) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipRules (
                        name: "${name}",
                    ) {
                        id
                        name,
                        is_real_time,
                        is_unique_dispatch,
                        repeat_each_time,
                        repeat_each_seasonality,
                        ruleEventType {
                            id,
                            name
                        },
                        stops_at,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateRelationshipRule (
                        id: ${id},
                        name: "${data.name}",
                        is_real_time: ${data.is_real_time},
                        is_unique_dispatch: ${data.is_unique_dispatch},
                        repeat_each_time: ${data.repeat_each_time},
                        repeat_each_seasonality: ${data.repeat_each_seasonality},
                        rule_event_type_id: ${data.rule_event_type_id},
                        stops_at: ` + (data.stops_at !== undefined && data.stops_at !== null ? `"${data.stops_at}"` : null) + `
                    ) {
                        id
                        name,
                        is_real_time,
                        is_unique_dispatch,
                        repeat_each_time,
                        repeat_each_seasonality,
                        ruleEventType {
                            id,
                            name
                        },
                        stops_at,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createRelationshipRule (
                        name: "${data.name}",
                        is_real_time: ${data.is_real_time},
                        is_unique_dispatch: ${data.is_unique_dispatch},
                        repeat_each_time: ${data.repeat_each_time},
                        repeat_each_seasonality: ${data.repeat_each_seasonality},
                        rule_event_type_id: ${data.rule_event_type_id},
                        stops_at: ` + (data.stops_at !== undefined && data.stops_at !== null ? `"${data.stops_at}"` : null) + `
                    ) {
                        id
                        name,
                        is_real_time,
                        is_unique_dispatch,
                        repeat_each_time,
                        repeat_each_seasonality,
                        ruleEventType {
                            id,
                            name
                        },
                        stops_at,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteRelationshipRule (
                        id: ${id}
                    )
                }
            `
        })
    },
    fetchPaginated: (sortName = "id", page, itemsPerPage, type = "ASC", word = "") => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', formatGraphqlBody(
          'query',
          'getRelationshipRulePaginated',
          {
            0: 'pagination_page',
            1: 'pagination_limit',
            2: 'total_pages',
            3: 'total_items',
            items: {
                0: 'id',
                1: 'name',
                2: 'is_real_time',
                3: 'is_unique_dispatch',
                4: 'repeat_each_time',
                5: 'repeat_each_seasonality',
                6: 'rule_event_type_id',
                7: 'stops_at',
                ruleEventType: {
                    0: 'id',
                    1: 'name'
                },
                categories: {
                    0: 'id',
                    1: 'name',
                    2: 'color_tag'
                }
            }
          },
          {
            orderBy: [sortName, type],
            search_filter: word,
            pagination_page: page,
            pagination_limit: itemsPerPage
          }
        ));
      },
}